const DEFAULT_PRINT_DELAY_MS = 300;
const DEFAULT_CLEANUP_DELAY_MS = 2000;

export function printReceiptHtmlViaBrowser(html, options = {}) {
    const {
        documentRef = typeof document !== 'undefined' ? document : null,
        setTimeoutFn = setTimeout,
        printDelayMs = DEFAULT_PRINT_DELAY_MS,
        cleanupDelayMs = DEFAULT_CLEANUP_DELAY_MS,
        onError = console.error,
    } = options;

    if (!html || !documentRef?.body || !documentRef.createElement) return null;

    try {
        const frame = documentRef.createElement('iframe');
        frame.setAttribute('aria-hidden', 'true');
        frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';

        let printScheduled = false;
        let cleaned = false;
        const cleanup = () => {
            if (cleaned) return;
            cleaned = true;
            try {
                documentRef.body.removeChild(frame);
            } catch (e) {
                /* noop */
            }
        };
        const printFrame = () => {
            try {
                frame.contentWindow?.focus?.();
                frame.contentWindow?.print?.();
            } catch (e) {
                /* noop */
            }
            setTimeoutFn(cleanup, cleanupDelayMs);
        };
        const schedulePrint = () => {
            if (printScheduled) return;
            printScheduled = true;
            setTimeoutFn(printFrame, printDelayMs);
        };

        frame.onload = schedulePrint;

        if ('srcdoc' in frame) {
            frame.srcdoc = html;
            documentRef.body.appendChild(frame);
        } else {
            documentRef.body.appendChild(frame);
            const frameDocument = frame.contentWindow
                ? frame.contentWindow.document
                : frame.contentDocument;
            frameDocument.open();
            frameDocument.write(html);
            frameDocument.close();
        }

        if (frame.contentWindow) frame.contentWindow.onafterprint = cleanup;
        return frame;
    } catch (e) {
        onError?.('Kiosk receipt print failed:', e);
        return null;
    }
}
